var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".score-module[data-v-798107ec]{overflow:hidden}.score-module .star-list .star[data-v-798107ec]{float:left;margin-right:.01rem;background-image:url(" + escape(require("../../assets/images/star-on.png")) + ");background-size:100% 100%}.score-module .star-list .star[data-v-798107ec]:last-child{margin-right:0}.score-module .star-list .star.half[data-v-798107ec]{background-image:url(" + escape(require("../../assets/images/star-half.png")) + ")}.score-module .star-list .star.off[data-v-798107ec]{background-image:url(" + escape(require("../../assets/images/star-off.png")) + ")}", ""]);

// exports
